import { DRAWING_TYPES } from '../../../shared/constants/drawable-types'
import { IMUP2DDrawableLocation } from '../../types'

export function sortDrawableLocationsToHaveAreasBelow(a: IMUP2DDrawableLocation, b: IMUP2DDrawableLocation) {
    if (a.shapeType === DRAWING_TYPES.AREA && b.shapeType !== DRAWING_TYPES.AREA) {
        return -1
    }
    if (a.shapeType !== DRAWING_TYPES.AREA && b.shapeType === DRAWING_TYPES.AREA) {
        return 1
    }

    return 0
}
